import React, { useState, useEffect } from 'react';

import colors from '../../../Utils/colors';
import { Button, Form, InputGroup } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import images from '../../../Utils/images';
import OtpVerifyPage from './OtpVerifyPage';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CheerioButton from '../../../Components/CheerioButton';
import { eventsend } from '../../../Config/analyticsFunctions';
import { trackEvent } from '../../../Services';
import { MenuItem, TextField } from '@mui/material';
import PhoneField from './PhoneField';
import PasswordField from './PasswordField';

export default function AuthSignUp({
  loginAction,
  openOtpAction,
  closeOtpAction,
  name,
  setName,
  countryCode,
  setCountryCode,
  numbervalue,
  setNumberValue,
  email,
  setEmail,
  companyName,
  setCompanyName,
  setPhoneOTPvalue,
  phoneOTPvalue,
  emailOTPvalue,
  setEmailOTPValue,
  emailOTPsent,
  phoneOTPsent,
  googleloginaction,
  password,
  setPassword,
  startTrialAction,
  phoneNumber,
  setPhoneNumber,
  setDirectPaymentID,
  btnDisabled,
  identity,
  setIdentity,
}) {
  const handleTrackEvent = async (event) => {
    if (email !== 'priam@cheerio.in') {
      try {
        const data = {
          email: email,
          event: event,
          properties: {
            userName: name,
            userPhone: phoneNumber,
            companyName: companyName,
          },
        };
        const response = await trackEvent(data);
        if (response?.flag) {
          console.log('event tracked successfully');
        } else {
          console.log('error in track event');
        }
      } catch (error) {
        console.log('error in track event', error);
      }
    }
  };
  const navigate = useNavigate();
  const validateAndSendOtpAction = () => {
    handleTrackEvent('signup_start_trial_button_clicked');
    //  signUpAction();
    eventsend('start_free_trial_signup_page_clicked');
    startTrialAction();
  };
  const [searchParams] = useSearchParams();
  const isAppSumo = searchParams.get('source') === 'appsumo';
  const appSumoEmail = searchParams.get('email');
  const isDirectPayment = searchParams.get('source') === 'payment';
  const paymentId = searchParams.get('paymentId');

  useEffect(() => {
    eventsend('signup_pageview_web');
    if (appSumoEmail) {
      setEmail(appSumoEmail);
    }
    if (isDirectPayment) {
      setDirectPaymentID(paymentId);
      // console.log('ssssss ', paymentId);
    }
  }, []);

  const token = localStorage.getItem('token');
  useEffect(() => {
    if (token) {
      console.log('Testing....');
      navigate('/creator');
    }
  }, [token]);

  const onchangePhone = (e, d, rv, fv) => {
    let no = fv.substring(fv.indexOf(' ') + 1);
    console.log('no  ', no);
    console.log('d.dialCode  ', d.dialCode);
    setCountryCode(d.dialCode);
    eventsend('dialcode_field_Sign_up-page_clicked');
    setNumberValue(no);
    setPhoneNumber(e);
    eventsend('Phone_field_Sign_up-page_clicked');
  };

  return (
    <div className="auth_authsignup">
      {/* <DeploymentBanner></DeploymentBanner> */}

      <div className="auth_authsignup__body">
        <div className="auth_authsignup__body__row1">
          {/* <h2>{isAppSumo || isDirectPayment ? 'Create Account' : 'Start free trial'}</h2> */}
          <img
            src={images.OBLogoText}
            style={{
              height: 40,
              width: 'auto',
              objectFit: 'contain',
              marginBlockEnd: 16,
            }}
          />
          <h2>{'Create Account'}</h2>
          {/* <div className="no_credit">
            <p>{'No credit card needed'}</p>
          </div> */}
        </div>
        {/* {!(isAppSumo || isDirectPayment) && (
          <p>{`Enter details and get started with your 7 days free trial & credits worth INR 500`}</p>
        )}{' '} */}
        <div className="auth_authsignup__body__input_container" style={{}}>
          {/* <h4>{'Name'}</h4>
          <input
            type="email"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="Enter here"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              eventsend('Name_field_Sign_up-page_clicked');
            }}
          /> */}
          <TextField
            className="my-3"
            id="full-name"
            placeholder="Full Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              eventsend('Name_field_Sign_up-page_clicked');
            }}
            fullWidth
            variant="outlined" // default border; focus color comes from theme.primary
            size="small"
          />

          <PhoneField
            countryCode={countryCode}
            onCountryCodeChange={(dc) => {
              setCountryCode(dc);
              eventsend('dialcode_field_Sign_up-page_clicked');
            }}
            phone={numbervalue}
            onPhoneChange={(digits) => {
              const fv = `+${countryCode} ${digits}`;
              const e = `${countryCode}${digits}`;
              setNumberValue(digits);
              setPhoneNumber(e);
              eventsend('Phone_field_Sign_up-page_clicked');
            }}
            analytics={(event) => eventsend(event)}
          />

          <TextField
            className="my-3"
            id="email-input"
            type="email"
            placeholder="Email Id"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              eventsend('Email_field_Sign_up-page_clicked');
            }}
            fullWidth
            variant="outlined"
            size="small"
            autoComplete="email"
          />

          <PasswordField password={password} setPassword={setPassword} eventsend={eventsend} />

          <TextField
            className="my-3"
            id="identity-input"
            placeholder="Identity"
            label="Identity"
            variant="outlined"
            fullWidth
            size="small"
            select
            value={identity}
            onChange={(e) => setIdentity(e.target.value)}
          >
            <MenuItem value="Content Creator">Content Creator</MenuItem>
            <MenuItem value="E-commerce Business">E-commerce Business</MenuItem>
            <MenuItem value="Agency">Agency</MenuItem>
            <MenuItem value="Social Media Marketeer">Social Media Marketeer</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>

          <TextField
            className="my-3"
            id="company-input"
            type="text"
            placeholder="Business Name"
            value={companyName}
            onChange={(e) => {
              eventsend('company_field_Sign_up-page_clicked');
              setCompanyName(e.target.value);
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </div>
        {/* <div className="auth_authsignup__body__input_container">
          <h4>{'Phone No'}</h4>
          <PhoneInput
            inputStyle={{ width: '100%' }}
            country={'in'}
            value={phoneNumber}
            onChange={onchangePhone}
          />
        </div> */}
        {/* <div className="auth_authsignup__body__input_container">
          <h4>{'Email'}</h4>
          <input
            type="email"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="Enter here"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              eventsend('Email_field_Sign_up-page_clicked');
            }}
          />
        </div> */}
        {/* <div className="auth_authsignup__body__input_container">
          <h4>Create Password</h4>
          <input
            type="password"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="Enter here"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              eventsend('Password_field_Sign_up-page_clicked');
            }}
          />
        </div> */}
        {/* <div className="auth_authsignup__body__input_container">
          <h4>Company</h4>
          <input
            type="text"
            className="form-control"
            id="exampleFormControlInput1"
            placeholder="Enter here"
            value={companyName}
            onChange={(e) => {
              eventsend('company_field_Sign_up-page_clicked');
              setCompanyName(e.target.value);
            }}
          />
        </div> */}
        {/* <p style={{ textAlign: 'center', fontSize: 14 }}>
          {`By continuing, you are agreeing to our `}
          <span
            style={{ fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              window.open('https://www.cheerio.in/terms', '_blank');
            }}
          >
            {'Terms & Conditions'}
          </span>
          {` and `}
          <span
            style={{ fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              window.open('https://www.cheerio.in/privacy', '_blank');
            }}
          >
            {'Privacy policy'}
          </span>
          {`.`}
        </p> */}
        <div className="auth_authsignup__body__button_container">
          <CheerioButton
            borderStyle={{ width: '100%', border: `1px solid ${colors.primary03}` }}
            textStyle={{ fontSize: 16, fontWeight: 600, color: colors.white }}
            btnText={'Create Account'}
            // icon={images.HNUploadContacts}
            backColor={colors.primary03}
            onclick={validateAndSendOtpAction}
            disabled={btnDisabled}
          />
        </div>
      </div>

      <div className="auth_authsignup__row1" style={{}}>
        <h3 style={styles.haveAc}>
          {'Already have an account? '}
          <span
            style={{ color: colors.linkblue, cursor: 'pointer' }}
            onClick={() => {
              loginAction();
              setPassword('');
              setName('');
              setEmail('');
              setCompanyName('');
              setNumberValue('');
              setPhoneNumber('');
            }}
          >
            {'Login'}
          </span>
        </h3>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // height: 30,
    justifyContent: 'flex-end',
    width: '100%',
    paddingBlock: 8,
    // paddingRight: 20,
    // marginTop: 10,
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    // marginTop: 30,
    paddingLeft: '25%',
    paddingRight: '25%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  buttonStyle: {
    height: 40,
    // borderWidth: 1,
    // borderStyle: "solid",
    // borderColor: colors.white,
    borderRadius: 8,
    backgroundColor: colors.primary03,
    // display: "inline-block",
    fontSize: 16,
    fontWeight: 600,
    color: colors.black04,
    borderWidth: 1,
    width: '100%',
    backgroundColor: colors.white,
    borderColor: colors.greys01,
    marginTop: 20,
  },
  haveAc: {
    margin: 0,
    fontWeight: 400,
    fontSize: 16,
    color: colors.greys04,
    // marginLeft: "auto",
    // alignSelf: "flex-end",
  },
  noCredit: {
    backgroundColor: colors.green,
    fontSize: 12,
    padding: 5,
    paddingRight: 12,
    paddingLeft: 12,
    borderRadius: 8,
    color: colors.white,
    marginLeft: 8,
  },
  freeTrial: {
    margin: 0,
    fontSize: 24,
    fontWeight: 700,
    color: colors.black,
    fontWeight: 'bold',
  },
};
